import { render, staticRenderFns } from "./HistorySingoHolter2.vue?vue&type=template&id=e44fbd86&scoped=true&"
import script from "./HistorySingoHolter2.vue?vue&type=script&lang=js&"
export * from "./HistorySingoHolter2.vue?vue&type=script&lang=js&"
import style0 from "./HistorySingoHolter2.vue?vue&type=style&index=0&id=e44fbd86&lang=less&scoped=true&"
import style1 from "./HistorySingoHolter2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44fbd86",
  null
  
)

export default component.exports